import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Router, Routes } from 'react-router-dom';
import Dashboard from './pages/dashboard';
import SignIn from './pages/auth/sign-in';
import SignUp from './pages/auth/sign-up';
import Verify from './pages/auth/verify';
import Enroll from './pages/enroll';
import ClassroomActivity from './pages/classroom/classroom';
import AssessmentDetail from './pages/classroom/assessments/assessment-detail';
import CollectionDetails from './pages/classroom/library/collection-detail';
import NoteReader from './pages/classroom/library/components/note-reader/home';
import Account from './pages/account/account';
import ResetPassword from './pages/auth/reset-password';
import { AuthProvider } from './auth/AuthProvider';
import ProtectedRoute from './auth/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path='/enroll/:enrollment_code' element={<Enroll/>} />
          <Route path='/' element={
            <ProtectedRoute>
              <Dashboard/>
            </ProtectedRoute>
          } />
          <Route path='/sign-in' element={<SignIn/>} />
          <Route path='/sign-up' element={<SignUp/>} />
          <Route path='/reset-password' element={<ResetPassword/>} />
          <Route path='/verify/:action' element={<Verify/>} />
          <Route path='/account' element={
            <ProtectedRoute>
              <Account/>
            </ProtectedRoute>
          } />
          <Route path='/classrooms/:classroom_id' element={
            <ProtectedRoute>
              <ClassroomActivity/>
            </ProtectedRoute>
          } />
          <Route path='/classrooms/:classroom_id/assessments/:assessment_id' element={
            <ProtectedRoute>
              <AssessmentDetail/>
            </ProtectedRoute>
          } />
          <Route path='/classrooms/:classroom_id/library/collections/:collection_id' element={
            <ProtectedRoute>
              <CollectionDetails/>
            </ProtectedRoute>
          } />
          <Route path='/classrooms/:classroom_id/library/collections/:collection_id/notes' element={
            <ProtectedRoute>
              <NoteReader/>
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
